// @flow
import * as React from 'react'
import type {
  PropsSchema,
  EasyAction,
  EventSourceMap,
  BasicProps
} from '../../../type'
import computeData from '../../hoc/computeData'
import styles from './CardDraw.scss'
import $ from 'jquery'

type Props = BasicProps & {
  customProps: {
    $comp: {
      cardConfig?: {
        backgroundImage?: {
          url: string
        },
        defaultImage?: {
          url: string
        },
        turnImage?: {
          url: string
        }
      }
    }
  },
  startTurn: boolean,
  targetNum: number,
  children: React.ChildrenArray<React.Node>,
  events: EventSourceMap,
  callActions: (actionName: string, dynamicData: any) => {},
  backgroundImage: ?{
    url: string
  },
  defaultImage: ?{
    url: string
  },
  turnImage: ?{
    url: string
  }
};

type State = {
  allfront0: boolean,
  allfront1: boolean,
  allfront2: boolean,
  allfront3: boolean,
  allfront4: boolean,
  allfront5: boolean,
  allfront6: boolean,
  allfront7: boolean,
  beginLuckDraw: boolean,
  isopen: boolean,
  targetNum: number
};

@computeData({ includeData: true })
export default class extends React.PureComponent<Props, State> {
  static schema: PropsSchema = [
    {
      type: 'image',
      key: 'backgroundImage',
      title: '背景图片'
    },
    {
      type: 'image',
      key: 'defaultImage',
      title: '正面奖品图片'
    },
    {
      type: 'image',
      key: 'turnImage',
      title: '背面奖品图片'
    },
    'separator',
    {
      type: 'event',
      event: 'stop',
      title: '停止'
    }
  ];
  static actions: EasyAction[] = [
    {
      title: '开始',
      name: 'begin'
    },
    {
      title: '初始化卡牌',
      name: 'initCard'
    }
  ];
  drawing: boolean;
  readyDarwimg: boolean;
  constructor (props: Props) {
    super(props)
    this.state = {
      allfront0: true,
      allfront1: true,
      allfront2: true,
      allfront3: true,
      allfront4: true,
      allfront5: true,
      allfront6: true,
      allfront7: true,
      beginLuckDraw: true,
      isopen: false,
      targetNum: -1
    }
  }
  componentWillUnmount () {}

  actionInitCard = () => {
    let { customProps = {}, jsEnv, turnImage } = this.props
    let cardConfig =
      customProps.$comp && customProps.$comp.cardConfig
        ? customProps.$comp.cardConfig
        : {}
    turnImage = turnImage || cardConfig.turnImage || {}
    let turnImageUrl = jsEnv.getString(turnImage.url || '')
    $(this.refs.projectBox)
      .find(`.${styles.front}`)
      .css({ backgroundPosition: '' })
    $(this.refs.projectBox)
      .find(`.${styles.back}`)
      .css({
        backgroundPosition: '',
        backgroundImage: `url(${turnImageUrl})`,
        opacity: 1
      })
    $(this.refs.projectBox)
      .find(`.${styles.masks}`)
      .css({ display: 'none' })
    this.setState({
      isopen: false,
      beginLuckDraw: true
    })
  };

  actionBegin = (data: void, dynamicData: { targetNum: number }) => {
    let _this = this
    this.setState({
      targetNum: dynamicData.targetNum
    })
    if (_this.drawing) {
      return
    }
    _this.drawing = true
    if (_this.state.beginLuckDraw) {
      _this.readyDarwimg = false
      _this.setState({ beginLuckDraw: !_this.state.beginLuckDraw })
      _this.setState({ isopen: !_this.state.isopen })
      for (let i = 0; i < 8; i++) {
        let allfronti
        setTimeout(function () {
          allfronti = `allfront${i}`
          _this.setState({ [allfronti]: !_this.state.allfront7 })
        }, 10 + i * 50)
        setTimeout(function () {
          allfronti = `allfront${i}`
          _this.setState({ [allfronti]: !_this.state.allfront7 })
        }, 1450 + i * 50)
        setTimeout(function () {
          let projectBox = _this.refs.projectBox
          projectBox.addEventListener('click', _this.cardClick)
        }, 2500)
      }
    }
  };

  cardClick = (e: SyntheticEvent<HTMLDivElement>) => {
    let projectBox = this.refs.projectBox
    projectBox.removeEventListener('click', this.cardClick)
    let _this = this
    let { customProps = {}, jsEnv, defaultImage } = this.props
    let cardConfig =
      customProps.$comp && customProps.$comp.cardConfig
        ? customProps.$comp.cardConfig
        : {}
    defaultImage = defaultImage || cardConfig.defaultImage || {}
    let defaultImageUrl = jsEnv.getString(defaultImage.url || '')
    let { targetNum } = _this.state
    // $FlowFixMe
    let targetParentNode: HTMLDivElement = e.target.parentNode
    targetParentNode.classList.remove(`${styles.open}`)
    let positionBNum = 6
    let positionA = $(targetParentNode)
      .find(`.${styles.front}`)
      .css('backgroundPosition')
    switch (targetNum) {
      case 1:
        $(targetParentNode)
          .find(`.${styles.front}`)
          .css({ backgroundPosition: '0 0' })
        positionBNum = 1
        break
      case 2:
        $(targetParentNode)
          .find(`.${styles.front}`)
          .css({ backgroundPosition: '50% 0' })
        positionBNum = 2
        break
      case 3:
        $(targetParentNode)
          .find(`.${styles.front}`)
          .css({ backgroundPosition: '100% 0' })
        positionBNum = 3
        break
      case 4:
        $(targetParentNode)
          .find(`.${styles.front}`)
          .css({ backgroundPosition: '100% 50%' })
        positionBNum = 5
        break
      case 5:
        $(targetParentNode)
          .find(`.${styles.front}`)
          .css({ backgroundPosition: '100% 100%' })
        positionBNum = 8
        break
      case 6:
        $(targetParentNode)
          .find(`.${styles.front}`)
          .css({ backgroundPosition: '50% 100%' })
        positionBNum = 7
        break
      case 7:
        $(targetParentNode)
          .find(`.${styles.front}`)
          .css({ backgroundPosition: '0 100%' })
        positionBNum = 6
        break
      case 8:
        $(targetParentNode)
          .find(`.${styles.front}`)
          .css({ backgroundPosition: '0 50%' })
        positionBNum = 4
        break
      default:
        $(targetParentNode)
          .find(`.${styles.front}`)
          .css({ backgroundPosition: '0 100%' })
    }
    // $FlowFixMe
    $(targetParentNode.parentNode)
      .children('div')
      .eq(positionBNum - 1)
      .find(`.${styles.back}`)
      .css({ backgroundPosition: positionA })
    setTimeout(function () {
      _this.drawing = false
      $(targetParentNode)
        .siblings()
        .find(`.${styles.back}`)
        .css({
          backgroundImage: `url(${defaultImageUrl})`,
          opacity: 0.3
        })
      $(targetParentNode)
        .siblings()
        .find(`.${styles.masks}`)
        .css({
          display: 'block'
        })
      _this.props.callActions('stop')
    }, 800)
  };

  renderCards () {
    let { customProps = {}, jsEnv, defaultImage, turnImage } = this.props
    let cardConfig =
      customProps.$comp && customProps.$comp.cardConfig
        ? customProps.$comp.cardConfig
        : {}
    defaultImage = defaultImage || cardConfig.defaultImage || {}
    turnImage = turnImage || cardConfig.turnImage || {}
    let defaultImageUrl = jsEnv.getString(defaultImage.url || '')
    let turnImageUrl = jsEnv.getString(turnImage.url || '')
    let list = []
    for (let i = 0; i <= 7; i++) {
      list.push(
        <div
          key={i}
          className={`${styles.project} ${
            this.state[`allfront${i}`] ? styles[`ani${i}`] : styles.goback
          } ${this.state.isopen ? styles.open : ''}`}
        >
          <div
            className={styles.front}
            style={{ backgroundImage: `url(${defaultImageUrl})` }}
          />
          <div
            className={styles.back}
            style={{ backgroundImage: `url(${turnImageUrl})` }}
          />
          <div className={styles.masks} />
        </div>
      )
    }
    return <div ref='projectBox'>{list}</div>
  }

  render () {
    let {
      customProps = {},
      jsEnv,
      children,
      visible,
      backgroundImage,
      defaultImage,
      turnImage
    } = this.props
    let { beginLuckDraw } = this.state
    let cardConfig =
      customProps.$comp && customProps.$comp.cardConfig
        ? customProps.$comp.cardConfig
        : {}
    backgroundImage = backgroundImage || cardConfig.backgroundImage || {}
    defaultImage = defaultImage || cardConfig.defaultImage || {}
    turnImage = turnImage || cardConfig.turnImage || {}
    let backgroundImageUrl = jsEnv.getString(backgroundImage.url || '')
    let defaultImageUrl = jsEnv.getString(defaultImage.url || '')
    let turnImageUrl = jsEnv.getString(turnImage.url || '')
    if (!visible) {
      return null
    }
    return (
      <div
        className={`${styles.this}`}
        style={{
          backgroundImage: `url(${backgroundImageUrl})`
        }}
      >
        <div className={styles.cardbox}>
          <div className={styles.projects}>
            {this.renderCards()}
            <div
              className={styles.controls}
              style={{
                backgroundImage: `url(${
                  beginLuckDraw ? defaultImageUrl : turnImageUrl
                })`
              }}
            />
          </div>
        </div>
        {children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/ui/Draw/CardDraw.js